import { render } from "./EmployeeHeaderTable.vue?vue&type=template&id=6784a79f&ts=true"
import script from "./EmployeeHeaderTable.vue?vue&type=script&lang=ts"
export * from "./EmployeeHeaderTable.vue?vue&type=script&lang=ts"

import "./EmployeeHeaderTable.vue?vue&type=style&index=0&id=6784a79f&lang=scss"

import exportComponent from "/builds/harapan-jaya/ecosystem/web-hrd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__